module.exports = __webpack_public_path__ + "static/sec9-bg-8e30dc20fdab5181e2d0e0b8de5b71fa.jpg";